import { Section, highlight } from "./shared";

const COLORS = ["sticky-yellow", "sticky-pink", "sticky-blue", "sticky-green", "sticky-orange"];

export function StickyNotesSection({ items, regex }) {
  if (!items?.length) return null;
  return (
    <Section label="Sticky Reminders">
      <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-4 py-2">
        {items.map((text, i) => (
          <div
            key={i}
            data-testid={`sticky-note-${i}`}
            className={`sticky-note ${COLORS[i % COLORS.length]}`}
          >
            <span className="sticky-tape" aria-hidden />
            <p className="text-zinc-900">{highlight(text, regex)}</p>
          </div>
        ))}
      </div>
    </Section>
  );
}
